import axios from 'axios'
import {CADASTRAR_PRESTADOR} from '../types'
import {SLOW_REQUEST_CONFIG} from '../../util/loadingUtil'
import {URL} from '../../util/ambienteActions';

export default function cadastrarPrestador(prestador) {
    const url = `${URL}/prestador/cadastrar`;
    return dispatch => axios.post(url, prestador, SLOW_REQUEST_CONFIG).then(
        response => dispatch({
            type: CADASTRAR_PRESTADOR,
            payload: response
        })
    );
}
